import { useState } from "react";

export default function useToast() {
    const [toast, setToast] = useState({
        show: false,
        message: "",
        type: "success"
    });

    const showToast = (message, type = "success", duration = 3000) => {
        setToast({ show: true, message, type });

        setTimeout(() => {
            setToast((prev) => ({ ...prev, show: false }));
        }, duration);
    };

    return { toast, showToast };
}